import * as React from 'react'

export const ReservationReceiptModalHeader = (): JSX.Element => (
  <div className="row mx-0 font-size-sm bg-light border-bottom bg-dark-gray text-white fw-bold py-3">
    <div className="col-sm-6 col-5">Nazwa</div>
    <div className="col-4 col-sm-3 col-3 d-flex justify-content-end pe-0">Data dodania</div>
    <div className="col-3 d-flex justify-content-end">Kwota</div>
  </div>
)
